export const ALL_TIMES_RECEIVED = 'all-times-received';
export const CHANGE_AVAILABILITY_TIME_FILTER = 'change-availability-time-filter';
export const CHANGE_DOCTOR_LOCATION_IDS = 'change-doctor-locations';
export const CHANGE_GRID_TYPE = 'change-grid-type';
export const CHANGE_INSURANCE = 'change-insurance';
export const CHANGE_IS_EXISTING_PATIENT = 'change-is-existing-patient';
export const CHANGE_NUM_DAYS_VISIBLE = 'change-num-days-visible';
export const CHANGE_PROCEDURE = 'change-procedure';
export const CLICK_MORE_TIMES = 'click-more-times';
export const CLICK_NEXT_DAYS = 'click-next-days';
export const CLICK_PREV_DAYS = 'click-prev-days';
export const CLICK_SLOT = 'click-slot';
export const FETCH_TIMES = 'fetch-times';
export const JUMP_TO_DATE = 'jump-to-date';
export const RECEIVE_TIMES = 'receive-times';
export const SERVER_ERROR = 'server-error';
export const SHOW_CONSTRAINT = 'show-constraint';
